import { useState } from "react";
import { Card, Placeholder, Nav, ListGroup, Badge } from "react-bootstrap";
import { Entry, LeagueData, Standing } from "../types/leagueData";

export interface LeagueProps {
  data?: LeagueData;
  
}

function LeagueLoading() {
  return (
    <Card>
      <Card.Header>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder xs={6} />
        </Placeholder>
      </Card.Header>
    </Card>
  )
}

export function League(props: LeagueProps) {
  const [activeView, setActiveView] = useState<string>("Overall");

  if (!props.data) {
    return <LeagueLoading />
  }

  const standings: { [phase: string]: {name: string, player_name: string, points: number, position: number}[] } = {};

  props.data.standings.forEach((v: Standing) => {
    const entry = props.data?.entries.find((e: Entry) => v.entry_id === e.id);
    if (entry == undefined) {
      return;
    }
    if (standings[v.phase_name] === undefined) {
      standings[v.phase_name] = [];
    }
    standings[v.phase_name].push({name: entry?.name, player_name: entry?.player_name, points: v.points, position: v.position});

    // expensive but order the list each time
    standings[v.phase_name].sort((a, b) =>  b.points - a.points);
  })

  // Order the standings
  const navSelected = (v: string | null) => {
    if (!v) {
      return;
    }

    setActiveView(v.replace("#", ""))
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Standings</Card.Title>
      </Card.Header>
      <Card.Body>
        <Nav variant="tabs" defaultActiveKey={`#${activeView}`} onSelect={navSelected}>
          {Object.entries(standings).map(([key]) => {
            return <Nav.Item key={key}>
              <Nav.Link href={`#${key}`}>{key}</Nav.Link>
            </Nav.Item>
          })}
        </Nav>
      <ListGroup as="ol" numbered>
        {standings[activeView].map((p) => {
        return <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start"
          key={p.player_name}
        >
          <div className="ms-2 me-auto">
            <div className="fw-bold">{p.name}</div>
            {p.player_name}
          </div>
          <Badge bg="primary" pill>
            {p.points}
          </Badge>
        </ListGroup.Item>
        })}
      </ListGroup>
      </Card.Body>
    </Card>
  )
}
